export default __webpack_public_path__ + "static/media/640_portfolio02-nl-web.e99782e3.png";